import { useDropzone } from 'react-dropzone';
import React from 'react';
import classNames from 'classnames';
import './Attachment.scss';
import FontAwesomeIcon from '../Icon';
import Button from '../Button';
import { Attachments } from 'src/pages/ServiceRequests/components/Attachments';

interface AttachmentProps {
  onSelect: (files: File[]) => void;
  files: any[];
  clearFiles: () => void;
  icon?: any;
  isMultiple?: boolean;
}

const Attachment = ({
  onSelect,
  files,
  clearFiles,
  icon,
  isMultiple,
}: AttachmentProps) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'image/*,application/pdf',
    multiple: !!isMultiple,
    onDrop: (acceptedFiles) => {
      const imageSelected = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
      onSelect(imageSelected);
    },
  });

  return (
    <div className={`attachment-container${files.length > 0 ? ' attachment-container-has-file' : ''}`}>
      {files.length === 0 && (
        <div
          {...getRootProps({
            className: classNames('attachment-dropzone', {
              'attachment-dropzone-active': isDragActive,
            }),
          })}
        >
          <input {...getInputProps()} />
          {icon ? (
            <FontAwesomeIcon glyph="paperclip" weight="light" size="small" />
          ) : (
            <h4>Add Attachment</h4>
          )}
        </div>
      )}
      {files.length > 0 && (
        <>
          {files[0].type?.startsWith('image/') ? (
            <Attachments
              attachments={{
                hasAttachment: true,
                firstCompressedAttachment: files[0].preview,
                totalAttachments: 1,
              }}
              onClickAttachment={() => {}}
              fromMessages
              fileName={files[0].name}
              wide
            />
          ) : files[0].type === 'application/pdf' ? (
            <Attachments
              attachments={{ hasAttachment: true, totalAttachments: 1 }}
              onClickAttachment={() => {}}
              fromMessages
              isPdf
              fileName={files[0].name}
              wide
            />
          ) : (
            <span>{files[0].name}</span>
          )}
          <div className="delete-button">
            <Button
              color="semantic"
              label={<FontAwesomeIcon glyph="trash" weight="light" />}
              onClick={() => clearFiles()}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Attachment;
